module.exports = __webpack_public_path__ + "img/KIKE-SELE.39fb2471.jpg";